import { OperatorLogin } from "../../utils/ProcessAnalysis";
import { useProcessesInVisibleGroups } from "utils/customHooks/genericHooks";

export const blankOperator = {
  isAutoSignOutEnabled: false,
  isEnabled: false,
  isPinRequired: false,
  noSignOutGracePeriodSeconds: 1800,
} as OperatorLogin;

export const useMidgardProcesses = () => {
  const processes = useProcessesInVisibleGroups();

  return processes;
};
